<template>
  <div>
    <b-card header="Chaves Pix" header-tag="h6" class="mb-4">
      <b-form>
        <filtro-parceiro-conta
          ref="filtro"
          v-model="model"
          :showData="false"
          :showComboBanco="false"
          :showTipoQRCode="showTipoQRCode"
          parceiroSelected
          :contaAtivas="true"
        ></filtro-parceiro-conta>
      </b-form>
      <core-Grid2
        ref="grid"
        :onRead="onRead"
        :deleteOption="false"
        :addOption="false"
        :editOption="false"
        searchDisabled>
        <template slot="gridColumns">
          <kendo-grid-column field="codigo" hidden></kendo-grid-column>
          <kendo-grid-column
            field="chaveExibicao"
            :width="600"
            title="Chave"
          ></kendo-grid-column>
          <kendo-grid-column
            field="tipoChave"
            title="Tipo Chave"
            :values="$api.Arrays.TipoChavePix"
          ></kendo-grid-column>
          <kendo-grid-column
            field="situacaoChavePix"
            title="Situação Chave"
            :values="$api.Arrays.SituacaoChavePix"
          ></kendo-grid-column>
        </template>
      </core-Grid2>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    showTipoQRCode: { type: Boolean, default: false }
  },
  data () {
    return {
      model: {}
    }
  },
  watch: {
    model: {
      deep: true,
      handler (val) {
        this.refresh()
      }
    }
  },
  methods: {
    response (data) {
      if (data) {
        this.refresh()
      }
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    onRead: function (options, search) {
      if (!this.model.conta) {
        options.success([])
      } else {
        let th = this
        let dto = {
          parameters: [
            { name: 'filter', value: search },
            { name: 'codigoConta', value: this.model.conta }
          ]
        }
        this.getCorrentistas(this.model.conta)
        let api = this.$api
        this.$api.ContaChavePix.GetAll(dto).then(function (response) {
          th.tiposChaveCadastrados = response
            .filter(el => el.tipoChave < 4)
            .map(el => el.tipoChave)
          if (th.tiposChaveCadastrados.includes(0)) {
            th.tiposChaveCadastrados.push(-1)
            th.tiposChaveCadastrados.push(1)
          } else if (th.tiposChaveCadastrados.includes(1)) {
            th.tiposChaveCadastrados.push(-1)
          }
          response.forEach(el => {
            if (el.tipoChave < 2) {
              el.chaveExibicao = api.UI.Format.DocumentoFederal(el.chave)
            } else if (el.tipoChave === 2) {
              el.chaveExibicao = el.chave.replace('+55', '')
              el.chaveExibicao = api.UI.Format.Telefone(el.chaveExibicao)
            } else {
              el.chaveExibicao = el.chave
            }
          })
          options.success(response)
        })
      }
    },
    getCorrentistas (codigoConta) {
      if (!codigoConta) return
      let th = this
      this.$api.ContaCorrentistas.GetCorrentistaTitular(codigoConta).then(
        function (response) {
          if (th.$api.UI.PostAction(response, '', false)) {
            th.correntistas = [
              {
                value: response.codigoCorrentista,
                text: response.nome,
                documentoFederal: response.documentoFederal,
                tipoPessoa: response.tipoPessoa,
                titularidade: response.titularidade
              }
            ]
          }
        }
      )
    }
  }
}
</script>
